import { useInstancesByQuery } from 'hive-react-utils';
export function useResponseCareTipsByDate(startDate, endDate) {
    return useInstancesByQuery('ecarepd', 'responseCareTipsByDate', 'responseCareTip', {}, startDate, endDate);
}
